import React from "react";
import PaymentlinkonEmail_json_data from "./LinkBasedAPI-Json-data/PaymentlinkonEmail_json_data";
import PaymentlinkonApi_json_data from "./LinkBasedAPI-Json-data/PaymentlinkonApi_json_data";

function Linkbasedapi() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>LINK BASED API</h2>
              <hr />
            </section>

            {/*  JS Checkout flow video: strat */}
            {/*  JS Checkout flow video. end */}

            <section id="idocs_content" class="mt-20 mb-20">
              <h3>API’S:</h3>
              <hr />
            </section>

            <section id="idocs_content" class="mt-20 mb-20">
              <h3> 1. API to receive Payment link on Email Id & SMS:</h3>
              <hr />
            </section>

            <p>
              This API is use to create MediaBasedPaymentLink and send it to
              respective Email Id and SMS which are given in the request.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">URL</td>
                  <td>
                    <a href="https://uatportal.safexpay.ae/sdk/paymentByLink">
                      https://uatportal.safexpay.ae/sdk/paymentByLink
                    </a>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Method</td>
                  <td>POST</td>
                </tr>
                <tr>
                  <td className="table-color">Content-Type</td>
                  <td>Application-JSON </td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Parameters to be passed in the Header Section:</h4>
            </u>

            <table class="table table-bordered table-padding-sec">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">me_id : 202312210004</td>
                  <td>(This is just a Test MID)</td>
                </tr>
              </tbody>
            </table>

            <div className="para-underline">
              <p>
                <span>Note: </span> The above request will be encrypted using
                the Merchant Encryption Key.
              </p>
            </div>

            <h4>Encrypted Request :</h4>

            <p className="linkbase-para-sec">
              F7wCfysi4aTze9nG3iiqtdXQMykWJdBKfY446igqrWuAyto7yoGi1Gk1TrHfUzSod8DC34fQgznZzoA
              QuGDkuzccUtHNnbt2AQiah+MbmtjQAOJ9QIsVztvAztGYq/NALYc3UYOYW/yzFxlLgVoVkOnAjW
              OY+i5HGVMnhB66P71WQ6Qvgf97pQeK9pJPj4Svdipu0TQ/V91tZr9Z54LMKU+/Q462y14IhhHhb
              ZpHUMoh5M5l5C+T9+adnGC82iiKfYoKLr1vAOUUtLuPiMSKgd/4NQ2uayfDgZqzl7P1Yet8U3zbdJ
              ydaiAfKDsjlj/uScKitDuV62YSshJhjK5/XEU+hlO6Xum6d2NTXm9PMHoQnGsNcmmXw9PPm9h219
              J3/Fon0fGPuDU/VNEJJfaRJ7r7u2RQQkrY2EfO1ZrGczhUqtnGEUoaSgf74cYG14NaavDX7f1l3rEd3
              BujTe22QMZpFWCqawoTUbAQqbYTaYp54vy43OwFvjpm3oGvIVU9plpto+w4cU5gnDEzHiEVI29
              6QEs6m4MzCHrfc7ZNLZEkg3Zt3+ur4zSdRxxSODU4NRmJpIJjsWIVDgE1G18VARmKAi2Et5VAgC8
              gTRAoQW4=
            </p>

            <h4>Postman Request:</h4>
              <p >&#123;</p>
            <span className="linkbase-para-sec">
              "request":"F7wCfysi4aTze9nG3iiqtdXQMykWJdBKfY446igqrWuAyto7yoGi1Gk1TrHfUzSod8DC34fQgznZz
              oAQuGDkuzccUtHNnbt2AQiah+MbmtjQAOJ9QIsVztvAztGYq/NALYc3UYOYW/yzFxlLgVoVkOnAjWOY+i5
              HGVMnhB66P71WQ6Qvgf97pQeK9pJPj4Svdipu0TQ/V91tZr9Z54LMKU+/Q462y14IhhHhbZpHUMoh5M5
              l5C+T9+adnGC82iiKfYoKLr1vAOUUtLuPiMSKgd/4NQ2uayfDgZqzl7P1Yet8U3zbdJydaiAfKDsjlj/uScKitDuV6
              2YSshJhjK5/XEU+hlO6Xum6d2NTXm9PMHoQnGsNcmmXw9PPm9h219J3/Fon0fGPuDU/VNEJJfaRJ7r7u2
              RQQkrY2EfO1ZrGczhUqtnGEUoaSgf74cYG14NaavDX7f1l3rEd3BujTe22QMZpFWCqawoTUbAQqbYTaYp5
              4vy43OwFvjpm3oGvIVU9plpto+w4cU5gnDEzHiEVI296QEs6m4MzCHrfc7ZNLZEkg3Zt3+ur4zSdRxxSODU4
              NRmJpIJjsWIVDgE1G18VARmKAi2Et5VAgC8gTRAoQW4="
            </span>
              <p>&#125;</p>

            {/* <h3>Screenshot for Reference::</h3>

         

            <div className="demo-img">
              <img src="#" alt="image-pending" width="100px" className="demo-style" />
            </div> */}

            <div className="resq-param">
              <h4>Response</h4>
              <p>
                clicktowishResponse [status = success, message = null, data ={" "}
                <span>&#123;</span>"result":"Email and SMS has been sent
                successfully to the
                customer","linkId":"659fb5ee6e07121033ffec65","orderId":"021111222111hu1QQQ"{" "}
                <span>&#125;</span>, hasErrors = false, errors=null]
              </p>

              <div className="resq-param-decr">
                {/* <h3>Screenshot for reference:</h3>

                <img
                  src="assets/images/"
                  alt="logo"
                  className="resq-param"
                  width="100%"
                  height="300"
                /> */}

                <p className="para-blod">Note : </p>
                <p>
                  The payment link will be shared on the Email Id and SMS which
                  is mentioned in the request.
                </p>
              </div>
            </div>

            <section id="idocs_content" class="mt-20 mb-20">
              <h3> 2. API to receive Payment link in the Response :</h3>
              <hr />
            </section>

            <p>
              This API is use to create MediaBasedPaymentLink and it will sent
              the Payment Link as a response
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">URL</td>
                  <td>
                    <a href="https://uatportal.safexpay.ae/sdk/paymentByLinkResponse">https://uatportal.safexpay.ae/sdk/paymentByLinkResponse</a>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Method</td>
                  <td>POST</td>
                </tr>
                <tr>
                  <td className="table-color">Content-Type</td>
                  <td>Application-JSON </td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Parameters to be passed in the Header Section:</h4>
            </u>

            <table class="table table-bordered table-padding-sec">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">me_id : 202312210004</td>
                  <td>(This is just a Test MID)</td>
                </tr>
              </tbody>
            </table>

            <div className="para-underline">
              <p>
                <span>Note: </span> The above request will be encrypted using
                the Merchant Encryption Key.
              </p>
            </div>

            <h4>Encrypted Request :</h4>

            <p className="linkbase-para-sec">
              F7wCfysi4aTze9nG3iiqtdXQMykWJdBKfY446igqrWuAyto7yoGi1Gk1TrHfUzSod8DC34fQgz
              nZzoAQuGDku3BGLnL8TVcoKypi09LmVSzwoSVSrv/wzoX0pa1SDs4gkhs78xbXe/evzk2EX7b
              R3ACVUVIaSAZbMlDx7rBzbidlEf9OcHfyF0kDGPKqknl85pCwsM+iGitK1MWsxtrslsy7JeGFJJe
              D23n3VI9WZ0Ha8dAsWcsOzM+poUvSwpPRaLJ4jE+o+I9B03XTKWp0eofULLkZ26GxdnjZofk
              aT8U7bmXZTsK6Aax7J7lEyZKmUz8gitn+gYbcKkN1e7PJv39a6c3Z2ATmjL/KKAIwYMx1LMxS
              ZIRcYOwR6Rrk/NMZS1fdTLsU6cDjl9GfNX/llYw85tZaZkcEi1v/9nMwrWpvlJMPUzJqR+feVaT
              hbaY+YG4txN4TS7qNU/Ejgvnq9ErQZR6aYDUSwYp6VT2AnbdcS5Vx9LgR8Su361R6709dkwj
              7peonxJ2SHHdUyQGQZUj1N7KSWqmKYCk5whQ7vhLylhISnfDCr7UInQ5Oz8DBmZRr35f6F
              WmXkpRN1O6RaA==
            </p>

            <h4>Postman Request:</h4>
              <p>&#123;</p>
            <span className="linkbase-para-sec">
              "request":"F7wCfysi4aTze9nG3iiqtdXQMykWJdBKfY446igqrWuAyto7yoGi1Gk1TrHfUzSod8DC34fQ
              gznZzoAQuGDku3BGLnL8TVcoKypi09LmVSzwoSVSrv/wzoX0pa1SDs4gkhs78xbXe/evzk2EX7bR3AC
              VUVIaSAZbMlDx7rBzbidlEf9OcHfyF0kDGPKqknl85pCwsM+iGitK1MWsxtrslsy7JeGFJJeD23n3VI9WZ
              0Ha8dAsWcsOzM+poUvSwpPRaLJ4jE+o+I9B03XTKWp0eofULLkZ26GxdnjZofkaT8U7bmXZTsK6Aax
              7J7lEyZKmUz8gitn+gYbcKkN1e7PJv39a6c3Z2ATmjL/KKAIwYMx1LMxSZIRcYOwR6Rrk/NMZS1fdTLs
              U6cDjl9GfNX/llYw85tZaZkcEi1v/9nMwrWpvlJMPUzJqR+feVaThbaY+YG4txN4TS7qNU/Ejgvnq9ErQZ
              R6aYDUSwYp6VT2AnbdcS5Vx9LgR8Su361R6709dkwj7peonxJ2SHHdUyQGQZUj1N7KSWqmKYCk5
              whQ7vhLylhISnfDCr7UInQ5Oz8DBmZRr35f6FWmXkpRN1O6RaA=="
            </span>
              <p>&#125;</p>

            <h4>Encrypted Request :</h4>

            <p className="linkbase-para-sec">
              x+E3qg+8S+aLsJTHktZ1iXgMBi2wXLxs5TkMNZ6kSpiu5SvFyT3FlWAg+X2nlK1mlj6i10K0OgfJfwXj3zb
              PiB1DTO8ngfS/6sMqDVaAcZM2XpNDmxPFPHRshlD2vU/DXygF4u9KBIMg0IrRVZpMGYjVfc/Yoo6H
              HLjjxw6my41AVgOnk2kAkZYomvBln9Lm1+c0jfXt4Rf0bA+KIdGnCIN/B72dtc2WShJWpuzXjozrBRbe
              gcjCdth6KWbmCNjOpELQ8+jUbS0joMmmfz57QnlY3h5FwUjykXjgCtWOkLsThRilGHi7iE0KR1Vv1JxE
              tHYo4hvzzPqdmPi9oma6oUQ1rYx8J4QM5UkHcL7/pquknaI5/1MNGQLYFcomEgCt0QCEXgWEGeZEI
              1B3jHQH4m02s3g0ojDvKAnNoKgDYR1qpKS8zw6wnM/AaQl8StaT5YdoblmGzFeFl6JlxkhgBmquZeu
              Xhl3bRIPksv/37lk=
            </p>

            <h4>Decrypted response:</h4>

            <p>
              clicktowishResponse [status = success, message = null, data ={" "}
              <span>&#123;</span>
              "orderId":"021U7RT222111hu1QQQ","PaymentLink":"https://uatcheckout.safexpay.ae/ms-tr
              ansaction-core-1-0/paymentLinkRedirection/defaultPaymentLinkGatewayPage/etMVZIgu8XZD
              02kL8TbkJHdmJIDOsj5kr2J+BKGwJh55xEicroIgEwJzHMlhM0Ju","LinkId":"659fb6296e07121033
              ffec72" <span>&#125;</span>, hasErrors = false, errors=null]
            </p>


            <p className="para-blod">Note : </p>
                <p>
                In the response you will receive the payment link which can be used for the Payment.
                </p>
          </div>
          <div class="col-md-4">
            <PaymentlinkonEmail_json_data />
            <PaymentlinkonApi_json_data />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Linkbasedapi;
